<template>
  <div class="mp-box">
    <div @click="openMiniPro" class="open-btn">点击打开小程序</div>
  </div>
</template>
<script>
export default {
  data(){
    return{
      ticket: ""
    }
  },
  mounted(){
    this.initData();
  },
  methods:{
    openMiniPro(){
      if(this.ticket){
         window.location.href = `weixin://dl/business/?ticket=${this.ticket}`
      }
    },
    initData(){
       const getSearch = window.location.hash;
       console.log('getSearch',getSearch)
       if(getSearch){
         const ticket = this.getQueryVariable('t');
         console.log('ticket',ticket)
        //  window.location.href = `weixin://dl/business/?ticket=${ticket}`
        this.ticket = ticket
       }
    },
    // 获取url 返回的参数
    getQueryVariable(variable) {
      var query = window.location.hash;
      const info =  query.split("?")[1];
      if(info){
        const infoAr = info.split("&");
        for (var i = 0; i < infoAr.length; i++) {
          var pair = infoAr[i].split("=");
          if (pair[0] == variable) {
            return pair[1];
          }
        }
      } else {
        return false;
      }
      // var vars = query.split("?")[];
      // for (var i = 0; i < vars.length; i++) {
      //   var pair = vars[i].split("=");
      //   if (pair[0] == variable) {
      //     return pair[1];
      //   }
      // }
      // return false;
    },
  }
}
</script>

<style lang="scss" scoped>
.mp-box{
  width: 100%;
  .open-btn{
    width: 200px;
    height: 50px;
    background: #31BD71;
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    margin: 100px auto 0px auto;
    border-radius: 10px;
  }

}
</style>


